import { render } from "./NotFound.vue?vue&type=template&id=55e3e554&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=55e3e554&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e3e554"]])

export default __exports__